

// $Classes/Enums/Interfaces(filter)[template][separator]
// filter (optional): Matches the name or full name of the current item. * = match any, wrap in [] to match attributes or prefix with : to match interfaces or base classes.
// template: The template to repeat for each matched item
// separator (optional): A separator template that is placed between all templates e.g. $Properties[public $name: $Type][, ]

// More info: http://frhagn.github.io/Typewriter/

import { UserArea } from './UserArea';
import { LicenseType } from './LicenseType';
import { Profile } from './Profile';

export class UserDetails {
    
    public authenticationMethod: string = null;
    public areas: UserArea[] = [];
    public userID: number = 0;
    public userName: string = null;
    public deleteFlag: boolean = false;
    public name: string = null;
    public designation: string = null;
    public mobile: string = null;
    public password: string = null;
    public updateBy: number = null;
    public updateDatetime: Date = null;
    public email: string = null;
    public dateFormat: string = null;
    public license: LicenseType = null;
    public profileId: number = null;
    public profile: Profile = null;
    public superuser: boolean = false;
}

